import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { defaultLogo  } from '../../../env';
import { CloseIcon } from '../../../assets/icons/iconshere';


const OnLoadSection = ({ setShowTour,  showEndVideo }) => {
  const iframeRef = useRef(null);
  const [startTour, setStartTour] = useState(false);
  const configData = useSelector((state) => state.configSlice);
  const applications = useSelector(state => state.applicationSlice).apps;
  const walkThroughVideo = configData.config.walkThroughVideo;
  const body = document.body;


  const closeTour = () => {
    localStorage.setItem("tour", true)
    setShowTour(false);
    body.classList.remove('filter-active');
  };

  const iframeClick = () => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage('startPlayer', '*');
    }
  };

  

  return (
    <>
    <div className='onload-section'>
        <div className='active-overlay'>
         <iframe src={walkThroughVideo} title="_" ref={iframeRef} />
            <span className='close-btn' onClick={closeTour}>
            <CloseIcon/>
            </span>
            {
                startTour ?
                null
                :
                <div className='overlay-shadow'/>
            }
        </div>
    
        {!startTour &&  <div className='info-box'>
            <img 
              src={configData.config.logo || applications.filter((e) => e.uuid === configData.config.applicationId)[0]?.icon}
              onError={(e) => {
                  e.target.src = defaultLogo;
                  e.onerror = null;
              }}
              referrerPolicy={'no-referrer'}
              alt=''
            />
           
                <h6>Welcome to  XR learning library!</h6>
               
           
            <p>Welcome to the product tour of  XR learning library, a one stop solution for addressing the industrial skilling, technological and digital skill challenges across the entire industrial supply chain.</p>
           

            <span className='main-btns'>
           
                <button onClick={() => { setStartTour(true); iframeClick(); }}>Start</button>
               
            </span>
        </div>}

        {showEndVideo &&  <div className='info-box'>
        <img 
              src={configData.config.logo || applications.filter((e) => e.uuid === configData.config.applicationId)[0]?.icon}
              onError={(e) => {
                  e.target.src = defaultLogo;
                  e.onerror = null;
              }}
              referrerPolicy={'no-referrer'}
              alt=''
            />
           
                <h6>Thanks for taking the tour!</h6>
          
           
            <p>Schedule your live demo with our experts to upskill your workforce.</p>    
          

            <span className='main-btns'>
            
                <button onClick={()=>setShowTour(false)}>Explore</button>
          
            </span>
        </div>}

    </div>
    <div className="showoverlay"/>
    </>
 
  );
};

export default OnLoadSection;
